import { useAuth0 } from '@auth0/auth0-react';
import { Menu } from '@headlessui/react';
import { useAuthStore } from '../store/AuthStore';
import Button from './Button/Button';
import DropdownMenu from './DropdownMenu/DropdownMenu';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var UserAvatar = function UserAvatar() {
  var _user$first_name, _user$last_name;

  var _useAuth = useAuth0(),
      logout = _useAuth.logout;

  var _useAuthStore = useAuthStore(function (_ref) {
    var state = _ref.state;
    return state;
  }),
      user = _useAuthStore.user;

  return /*#__PURE__*/_jsxs("div", {
    className: "flex space-x-1",
    children: [user && /*#__PURE__*/_jsxs("div", {
      className: "bg-green-accent flex-shrink-0 rounded-xl p-2 text-center text-sm font-bold text-white",
      children: [(_user$first_name = user.first_name) === null || _user$first_name === void 0 ? void 0 : _user$first_name.charAt(0), (_user$last_name = user.last_name) === null || _user$last_name === void 0 ? void 0 : _user$last_name.charAt(0)]
    }), /*#__PURE__*/_jsx(DropdownMenu, {
      label: " ",
      children: /*#__PURE__*/_jsx(Menu.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          className: "w-full",
          color: "plain",
          onClick: function onClick() {
            return logout({
              logoutParams: {
                returnTo: window.location.origin
              }
            });
          },
          children: /*#__PURE__*/_jsx("span", {
            className: "inline-block w-full text-left",
            children: "Log out"
          })
        })
      })
    })]
  });
};